<script lang="ts">
  import LobbyMenuItem from "$lib/components/LobbyMenuItem.svelte";
  import HomeIcon from "$lib/icons/HomeIcon.svelte";
  import SlotsIcon from "$lib/icons/SlotsIcon.svelte";
  import DealerIcon from "$lib/icons/DealerIcon.svelte";
  import MiniGamesIcon from "$lib/icons/MiniGamesIcon.svelte";
  import Banner from "$lib/components/Banner/Banner.svelte";
  import type {LayoutData} from "../../../../.svelte-kit/types/src/routes/$types";
  import HeartIcon from "$lib/icons/HeartIcon.svelte";
  import type {IPromotion} from "$lib/interfaces/IPromotion";
  import {onMount} from "svelte";
  import {userService} from "$lib/services/user.service.js";
  import {writable} from "svelte/store";

  interface Props {
    data: LayoutData;
    children?: import('svelte').Snippet;
  }

  let { data, children }: Props = $props();

  let menuItems: any = [
    {title: "Lobby", url: "/casino", icon: HomeIcon},
    {title: "Slots", url: "/casino/slots", icon: SlotsIcon},
    {title: "Live Casino", url: "/casino/live-casino", icon: DealerIcon},
    {title: "Mini Games", url: "/casino/mini-games", icon: MiniGamesIcon}
  ]
  if (data.token) {
    menuItems.push({title: "Favorites", url: "/casino/favorites", icon: HeartIcon});
  }
  let mainBanner: IPromotion[] = $state([]);
  let showWelcomeBonuses = $state(true);

  // Check if welcome bonuses should be displayed
  async function checkBonusAvailability() {
    try {

      const response = await userService.checkBonusAvailability('DEPOSIT');


      if (response && response.data && response.data.data) {
        // Hide welcome bonuses if enabled is false and canToggle is false
        const shouldHide = response.data.data.enabled === false && response.data.data.canToggle === false;

        showWelcomeBonuses = !shouldHide;
      } else {
        showWelcomeBonuses = true; // Default to showing if response is invalid
      }
    } catch (error) {
      console.error('Casino - Error checking bonus availability:', error);
      // Default to showing bonuses if there's an error
      showWelcomeBonuses = true;
    }
  }

  // Filter out welcome bonuses if needed
  function filterPromotions(promotions: IPromotion[]) {
    if (!showWelcomeBonuses) {
      // Filter out fiat-welcome-bonus and crypto-welcome-bonus
      const filtered = promotions.filter(promo => {
        const isWelcomeBonus = promo.slug === 'fiat-welcome-bonus' || promo.slug === 'crypto-welcome-bonus';
        if (isWelcomeBonus) {
        }
        return !isWelcomeBonus;
      });
      return filtered;
    }
    return promotions;
  }

  onMount(async () => {
    try {
      // Check bonus availability first
      await checkBonusAvailability();

      // Then fetch and filter promotions
      const response = await userService.getPromotions();
      if (response && response.data && response.data.data) {
        const filteredPromotions = filterPromotions(response.data.data);

        mainBanner = filteredPromotions;
      }
    } catch (err) {
      console.error('Error in onMount:', err);
    }
  })

</script>

<div class="mb-6">
  <Banner items={mainBanner} />
</div>

<div class="flex gap-1 text-white">
  {#each menuItems as item}
    <LobbyMenuItem data={item} />
  {/each}
</div>

{@render children?.()}
